import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { googleAuthApiRef } from '@backstage/core-plugin-api';

/**
 * Google Workspace sign-in for the Atteniv portal.
 *
 * `auto` skips the provider-chooser screen: there is exactly one provider, so
 * the user goes straight to Google. Domain restriction is enforced server-side
 * by the sign-in resolvers in app-config.production.yaml (and should also be
 * set as the `hd` parameter on the OAuth client), not here — this copy is
 * only a hint to the user.
 */
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props =>
          (
            <SignInPage
              {...props}
              auto
              provider={{
                id: 'google-auth-provider',
                title: 'Atteniv Google Workspace',
                message: 'Sign in with your @atteniv.com Google account',
                apiRef: googleAuthApiRef,
              }}
            />
          ),
      },
    }),
  ],
});
